import BatterySelector from "../components/BatterySelector";
import LeadForm from "../components/LeadForm";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function FindBatteryPage() {
  const [selected, setSelected] = useState(null);
  const { pathname } = useLocation();

  // Ensure canonical always points to /find-battery even when the user lands on
  // the /find-battery/request alias (scroll-to-form UX helper). This prevents
  // Google from treating the two URLs as duplicate content.
  useEffect(() => {
    const canonicalHref = "https://amaronbatterystore.com/find-battery";
    let el = document.querySelector('link[rel="canonical"]');
    const prev = el ? el.getAttribute("href") : null;
    if (!el) {
      el = document.createElement("link");
      el.setAttribute("rel", "canonical");
      document.head.appendChild(el);
    }
    el.setAttribute("href", canonicalHref);
    return () => { if (prev !== null) el.setAttribute("href", prev); };
  }, [pathname]);

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
      <div className="max-w-2xl">
        <div className="text-xs uppercase tracking-[0.24em] text-secondary font-bold">Find Product</div>
        <h1 className="font-display text-4xl md:text-5xl font-black mt-2 tracking-tighter">Pick the exact Amaron product for your vehicle or home.</h1>
        <p className="mt-4 text-muted-foreground">Choose your product category — Batteries, HUPS, Lubricants or Solar — answer a couple of questions and we will recommend the right Amaron product with capacity and warranty.</p>
      </div>
      <div className="mt-10">
        <BatterySelector onSelect={setSelected} />
      </div>
      <div className="mt-10">
        <LeadForm preselect={selected ? {
          product_category: selected.category,
          selected_brand: selected.brand_series,
          selected_model: selected.model_code,
        } : {}} />
      </div>
    </div>
  );
}
